<div  id="containerFoto" class="container">
    <img class="background-foto" src="../../../assets/images/Itinerari-esperienze/02_Sila/03_Mabos-Corazzo-Mabos/03_3_Abbazia-Corazzo.jpg">
<div class="content">
    <h1>Sila</h1>
    <h3>Arte e spiritualità in Sila</h3>
</div>
</div>
<br>
<div class="breadcrumb">
    <p><a>Scopri la Calabria</a> > <a>Parchi e Riserve</a> > <a>Parco Nazionale della Sila</a> > <a class="active">Arte e spiritualità in Sila</a></p>
</div>
<br>
<div id="fixed-element" [ngClass]="[isFixed ? 'fixed': 'notFixed']">
    <app-sidenav></app-sidenav>
</div>
<div class="row schedaItinerario">
    <h2>Arte e spiritualità in Sila</h2>
</div>
<br>
<div class="row schedaItinerario">
    <div class="col-xl-6 col-12">
        <img class="itinerario-foto" src="../../../assets/images/Itinerari-esperienze/02_Sila/03_Mabos-Corazzo-Mabos/03_3_Abbazia-Corazzo.jpg">
    </div>
    <div class="col-xl-4 ml-4 col-12">
        <div id="map" class="mapInfo"></div>
    </div>
</div>
<br>
<div class="row schedaItinerario">
    <div class="col-xl-6 col-12">
        <p class="testoItinerario">
            Questo itinerario offre un’esperienza inconsueta nella Sila Piccola, 
            non distante dall’area del Reventino e dalla Riserva delle Valli Cupe. 
            Si tratta di un territorio molto bello dal punto di vista paesaggistico contrassegnata dalla presenza di luoghi d’arte particolarmente 
            significativi ma anche di contesti storici emblematici legati alla vita di Gioacchino da Fiore, monaco cistercense ed esegeta nato a Celico, 
            in Sila, nel 1145 circa. 
            <br>
            <br>
            Il viaggio inizia dal Parco del Granaro dove si trova il Mabos, 
            il Museo di arte contemporanea nel bosco della Sila che offre un allestimento di oltre trentacinque opere site-specific distribuite 
            in trentamila metri quadri di bosco prodotte da artisti nazionali ed internazionali, durante le residenze d’artista SENSE, dal 2017 ad oggi. 
            All’interno anche il padiglione “Camera oscura” dedicato al reportage fotografico di Mario Giacomelli ispirato al Canto dei nuovi migranti 
            del poeta calabrese Franco Costabile.
            <br>
            <br>
            Il giorno seguente si apre con la camminata poetica che introduce alla conoscenza della vita e dell’opera di Gioacchino da Fiore, 
            sempre presso il Mabos, e da qui si prosegue in direzione di Castagna, località nel comune di Carlopoli, 
            per fare tappa all’Abbazia di Corazzo dove Gioacchino fu abate fino al 1187,
             un luogo in cui le rovine dell’immensa abbazia sulle rive del Corace creano un’ambientazione di struggente bellezza.
            <br>
            <br>
            Da qui il viaggio prosegue verso sud per raggiungere Taverna, il paese di Mattia Preti, 
            il celebre pittore del Seicento le cui opere sono state assimilate stilisticamente a quelle di Caravaggio. 
            I dipinti si possono ammirare nelle chiese, in particolare in quella di San Domenico e nell’attiguo Museo Civico dove 
            si trova anche una interessante collezione di opere d’arte contemporanea dedicata alla ricerca visiva del Novecento e 
            del primo ventennio del nostro secolo, costituita da opere polimateriche di noti maestri italiani, tra i quali: Ercole Drei, 
            Francesco Guerrieri, Lia Drei, Mimmo Rotella, Angelo Savelli, Mirella Bentivoglio, Concetto Pozzati, Aldo Turchiaro, Vasco Bendini.
             Da Taverna si riparte per fare rientro al Parco Hotel del Granaro.
        </p>
    </div>
    <div class="col-xl-4 ml-4 col-12">
        <div class="row">
            <div class="col">
                <h5>Percorso:</h5>
            </div>
            <div class="col right">
                <h5> in bici</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Difficoltà:</h5>
            </div>
            <div class="col right">
                <h5>difficile</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Lunghezza:</h5>
            </div>
            <div class="col right">
                <h5>63,3 Km</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Giorni:</h5>
            </div>
            <div class="col right">
                <h5>2</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Salita:</h5>
            </div>
            <div class="col right">
                <h5>1690 m</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Discesa:</h5>
            </div>
            <div class="col right">
                <h5>1690 m</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Luogo di Partenza:</h5>
            </div>
            <div class="col right">
                <h5>Parco Granaro (Sorbo San Basile)</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Luogo di arrivo:</h5>
            </div>
            <div class="col right">
                <h5>Parco Granaro (Sorbo San Basile)</h5>
            </div>
        </div>
        <div class="divider"></div>
    </div>
</div>
<br>
<br>
<div class="divider2">

</div>
<br>
<br>
<div class="row bannerPollino">
    <div class="col-9 col-xl-8">
        <h1 class="banner-header">ESPERIENZE E ITINERARI</h1>
        <br>
        <p>Scegli fra le tante idee di viaggio e proposte di itinerari tematici<br />per conoscere il Parco Nazionale della Sila.</p>
    </div>
    <div class="col-2 col-xl-1">
        <img src="../../../assets/images/03_Parchi-Riserve/logo-parco-sila.png">
    </div>
</div>
<br>
<br>
<div class="home-card">
    <div class="row">
        <div class="col-12 col-xl-3 one" id="one">
            <div class="card one">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Lungo le strade<br />della Ciclovia<br />dei Parchi</h1>
                        <a (click)="goToAcri()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 two" id="two">
            <div class="card two">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Gli storici villaggi<br />della Sila</h1>
                        <a (click)="goToLorica()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 three" id="three">
            <div class="card three">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Arte e spiritualità<br />in Sila</h1>
                        <a (click)="goToArte()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br>
<br>
<div class="divider2">
    
</div>
<br>
<br>
<app-mappe-tematiche></app-mappe-tematiche>
<br>
<br>

<div class="noMobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi <br />
                    iscriviti alla nostra newsletter ></h2>
            </div>
            <div class="col">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />
                    novità su proposte, esperienze, eventi e qualche curiosità.</p>  
            </div>
        </div>
        <div class="row">
            <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
        </div>
    </div>
</div>


<div class="mobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi<br />iscriviti alla nostra newsletter</h2>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-12">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <br>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />novità su proposte, esperienze, eventi e qualche curiosità.</p>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
            </div>
        </div>
    </div>
</div>
